import {NameValueDTO} from '../../common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';
import {ContactArrayDTO} from './ContactsArrayDTO';
import {ProviderContractLinkDTO} from './ProviderContractLinkDTO';
import {PriceListsArrayDTO} from './PriceListsArrayDTO';
import {AddressesArrayDTO} from './AddressesArrayDTO';
import {ProviderGroupLinkDTO} from './ProviderGroupLinkDTO';
import {ProviderUploadDTO} from './ProviderUploadDTO';
import {BankAccountDTO} from './BankAccountDTO';
import {ProviderSpecialtyLinkDTO} from './ProviderSpecialtyLinkDTO';

export class ProviderDTO extends BaseDTO {
  providerId: number;
  name: string;
  providerOrder: number;
  startDate: Date;
  endDate: Date;
  businessLicenseNumber: string;
  businessLicenseExpiryDate: Date;
  businessLicenseScannedCopy: string;
  vatNumber: string;
  vatOverride: boolean;
  gstNumber: string;
  gstOverride: boolean;
  sanctionCheckDate: Date;
  sanctionReference: string;
  sanctionIndicator: boolean;
  groupSettlement: number;
  billingId: number;
  note: NameValueDTO;
  bankAccount: BankAccountDTO;
  regulator: NameValueDTO;
  businessType: NameValueDTO;
  entityStatus: NameValueDTO;
  processingClass: NameValueDTO;
  providerFacilityType: NameValueDTO;
  country: NameValueDTO;
  addresses: AddressesArrayDTO[];
  contacts: ContactArrayDTO[];
  contracts: ProviderContractLinkDTO[];
  providerGroups: ProviderGroupLinkDTO[];
  providerSpecialties: ProviderSpecialtyLinkDTO[];
  practiceNumber: string;
  providerNetworkList: string;
}

export function CreateProviderDTOFromProviderUploadDTO(providerUploadDTO: ProviderUploadDTO): ProviderDTO {
  const providerDTO = new ProviderDTO();
  providerDTO.providerId = providerUploadDTO.providerId;
  providerDTO.name = providerUploadDTO.name;
  providerDTO.businessLicenseNumber = providerUploadDTO.businessLicenceNumber;
  return providerDTO;
}
